import React from 'react';

import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';

const PREFIX = 'IframeBanner';

const classes = {
    root: `${PREFIX}-root`
};

const Root = styled('iframe')(({theme: _theme}) => ({
    [`&.${classes.root}`]: {
        height: '100%',
        width: '100%',
        border: 'none',
        overflowY: 'hidden',
        overflowX: 'hidden',
        pointerEvents: 'none',
    }
}));

const styles = {
    container: {
        width: '100%',
        height: '100%',
    },
};

const IframeBanner = ({onClick,banner}) => {
    return <Box onClick={onClick} sx={styles.container}>
        <Root scrolling={null} src={banner.url} className={classes.root} title={banner.title} />
    </Box>;
};

export default IframeBanner;
